module.exports = __webpack_public_path__ + "img/new-logo-surf.14263671.svg";